var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode",style:({ width: ("" + _vm.size), height: ("" + _vm.size) })},[(!_vm.qrcodeUrl)?_c('div',{staticClass:"qrcode-loading"}):_c('img',{staticClass:"qrcode-img",attrs:{"src":_vm.qrcodeUrl,"alt":"qrcode"}})])}
var staticRenderFns = []

export { render, staticRenderFns }